import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ServicesProvider } from "@/context/ServicesContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import TrackPage from "@/pages/TrackPage";
import PartnerRegisterPage from "@/pages/PartnerRegisterPage";
import HirePanditPage from "@/pages/HirePanditPage";
import PanditRegisterPage from "@/pages/PanditRegisterPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import LocationPage from "@/pages/LocationPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import MyBookingsPage from "@/pages/MyBookingsPage";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Process OAuth return FIRST (synchronously during render) to avoid races.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/track" element={<TrackPage />} />
        <Route path="/track/:ref" element={<TrackPage />} />
        <Route path="/account/bookings" element={<MyBookingsPage />} />
        <Route path="/partner-register" element={<PartnerRegisterPage />} />
        <Route path="/hire-pandit" element={<HirePanditPage />} />
        <Route path="/pandit-register" element={<PanditRegisterPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/locations/:locality" element={<LocationPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/cancellation" element={<LegalPage type="cancellation" />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ServicesProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </ServicesProvider>
  );
}

export default App;
